module.exports = __webpack_public_path__ + "img/exhibit-intro.f2f85904.png";